<template>
  <CardPrimaryInverted
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <HeaderMediumPrimaryInverted>
      Create new workspace
    </HeaderMediumPrimaryInverted>
    <div :style="style.text">
      Create a new Zipteam workspace for your team.
    </div>
    <ButtonPrimary @click="$emit('create')">
      <GoogleMaterialIconPrimary
        :color="styleVariable.icon.color"
        content="add"
      />
    </ButtonPrimary>
  </CardPrimaryInverted>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardPrimaryInverted from '@modules/v2/card/card-primary-inverted'
  import GoogleMaterialIconPrimary
    from '@modules/v2/icon/google-material-icon-primary'
  import HeaderMediumPrimaryInverted
    from '@modules/v2/header/header-medium-primary-inverted'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CardCreateTenant',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      CardPrimaryInverted,
      GoogleMaterialIconPrimary,
      HeaderMediumPrimaryInverted,
    },
    data: function () {
      return {
        styleVariable: {
          icon: {
            color: null,
          },
        },
        style: {
          card: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '176px',
            justifyContent: 'space-between',
            padding: Layout.space.md,
            textAlign: 'center',
            width: '100%',
          },
          text: {},
        },
      };
    },
    created: function () {
      this.styleVariable.icon.color = this.color.light1();

      Object.assign(
        this.style.text,
        {
          color: this.color.light1(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
